'use strict';
import * as _ from 'lodash';
import moment from 'moment';
import { ClipBoardNoteDetailDialogModel } from './clipboardNoteDetail';
import * as constants from "../constants/patient-constants";

export class ClipBoardDetailDialogModel {
  constructor(config, data, editMode, title, ssn, patient, magView, localStorage, patClipPref, isViewOnly, isOffline, cannedNotes) {
    this.config = config;
    this.editMode = editMode;
    this.isOffline =  isOffline;

    this.resultData = data;
    this.data = _.cloneDeep(data);
    this.dataCopy = _.cloneDeep(data);

    this.scope = null;
    this.modalService = null;
    this.title = title.toUpperCase();

    this.ssn = ssn;

    this.Patient = patient;
    this.MagView = magView;
    this.LocalStorage = localStorage;

    this.patientNotesFilter = {
      keyword: ''
    };

    this.loading = false;
    this.selectedPatientNote = null;

    this.patClipPref = patClipPref;

    this.isViewOnly = isViewOnly;

    this.cannedNotes = cannedNotes;
  }

  init(modal, scope, modalService, ionicDatePicker) {
    this.scope = scope;
    this.modalInstance = modal;
    this.modalService = modalService;
    this.ionicDatePicker = ionicDatePicker;
  }

  _hasChanged() {
    const dCopy = _.cloneDeep(_.omit(this.dataCopy, ["PatientNotes"]));
    const dCopy2 = _.cloneDeep(_.omit(this.data, ["PatientNotes"]));

    return !_.isEqual(dCopy, dCopy2);
  }

  getDateString(date) {
    return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
  }

  async savePatClip() {
    try {
      if (this.loading) {
        return;
      }
      this.loading = true;

      const isOffline = await this.isOffline();
      if(!isOffline && this._hasChanged()) {
        if (!this.data.Id) {
          await this.create();
        } else {
          await this.update();
        }
        _.assign(this.resultData, this.data);
      }      

      if(!isOffline) {
        this.modalInstance.remove();
      }
      this.loading = false;
    } catch (error) {
      this.loading = false;
      await this.modalService.showErrorMessage(error.data);
    }
  }

  async create() {
    if (this.data.Flag) {
      this.data.Flag = this.data.Flag.toUpperCase();
    }

    const resp = await this.Patient.createPatClip(this.data);

    this.data.Id = resp.data;
  }

  async update() {
    if (this.data.Flag) {
      this.data.Flag = this.data.Flag.toUpperCase();
    }

    var resp = await this.Patient.updatePatClip(this.data);

    if (resp.data && resp.data === 'DELETED') {
      this.data = {};
    }
  }

  async closeWindow() {
    if (this._hasChanged()) {
      const confirmed = await this.modalService.showConfirmation(null, 'You have unsaved changes. Are you sure you want to cancel?');
      if (confirmed) {
        this.modalInstance.remove();
      }
      return;
    }
    this.modalInstance.remove();
  }

  changeDate() {

    if (this.isViewOnly) {
      return;
    }

    var dialog = this;
    var val = dialog.data.ExpDate;
    
    var minDate = moment().add(1, 'days').toDate();
    let maxDate = new Date(new Date().getFullYear() + 100, 11, 31);

    let ipObj = {
      callback: function (val) {
        let date = new Date(val);
        if (date > maxDate) {
          date = maxDate;
        }
        else if (date < minDate) {
          date = minDate;
        }
        let month = date.getMonth() + 1;
        let day = date.getDate();
        let year = date.getFullYear();
        dialog.data.ExpDate = month + '/' + day + '/' + year;
      },
      inputDate: !val || val === '/  /' || val === '//' ? new Date() : new Date(val),
      from: minDate,
      to: maxDate
    };

    this.ionicDatePicker.openDatePicker(ipObj);
  }

  patientNoteSelected(noteItem) {
    this.selectedPatientNote = noteItem;
  }

  searchInputKeyup() {
    this.selectedPatientNote = null;
  }

  async deletePatClipNoteItem() {
    const isOffline = await this.isOffline();
    if(isOffline || !this.selectedPatientNote) {
      return;
    }
    try {
      this.loading = true;
      await this.Patient.deletePatClipNote(this.selectedPatientNote.SSN, this.selectedPatientNote.Id);
      this.loading = false;
      this.data.PatientNotes.splice(this.data.PatientNotes.indexOf(this.selectedPatientNote), 1);
      this.selectedPatientNote = null;
    } catch (error) {
      await this.modalService.showErrorMessage(error.data);
    }
  }

  async modifyPatClipNoteItem() {
    const isOffline = await this.isOffline();
    if (!this.selectedPatientNote || isOffline) {
      return;
    }
    
    const resp = await this.Patient.loadPatClipNote(this.selectedPatientNote.SSN, this.selectedPatientNote.Id);
    if (resp.data) {
      this.selectedPatientNote.ADate = resp.data.ADate;
      this.selectedPatientNote.AUser = resp.data.AUser;
      this.selectedPatientNote.CNum = resp.data.CNum;
      this.selectedPatientNote.Clip = resp.data.Clip;
      this.selectedPatientNote.ExpDate = resp.data.ExpDate;
      this.selectedPatientNote.Flag = resp.data.Flag;
      this.selectedPatientNote.MDate = resp.data.MDate;
      this.selectedPatientNote.MUser = resp.data.MUser;
      this.selectedPatientNote.NoteNum = resp.data.NoteNum;
      this.selectedPatientNote.Type = resp.data.Type;
      this.selectedPatientNote.ClipboardOnly = this.selectedPatientNote.Type === 'C';

      const model = new ClipBoardNoteDetailDialogModel(this.selectedPatientNote, constants.PATIENT_NOTE_MODAL_TITLE, 
        this.Patient, this.LocalStorage, this.isOffline, this.modalService);
      await this.modalService.showDialogWindow('views/templates/clipboardNoteDialog.html', model, true);
    }
  }

  async addPatClipNoteItem() {
    const isOffline = await this.isOffline();
    if (!isOffline) {
      const resp = await this.MagView.getServerTimeNotUtc();
      const now = resp.data.now;
      const userInit = this.LocalStorage.get('UserLogin');
      let noteNum = 1;
      if (this.data.PatientNotes && _.isArray(this.data.PatientNotes) && this.data.PatientNotes.length) {
        noteNum = this.data.PatientNotes.map(n => n.NoteNum).sort()[this.data.PatientNotes.length - 1];
      }
      const data = {
        Id: null,
        SSN: this.ssn,
        Clip: '',
        Type: 'C',
        CNum: 0,
        NoteNum: noteNum,
        ADate: now,
        AUser: userInit,
        MDate: now,
        MUser: userInit,
        ExpDate: null,
        ClipboardOnly: true
      };

      const model = new ClipBoardNoteDetailDialogModel(data, constants.PATIENT_NOTE_MODAL_TITLE, 
        this.Patient, this.LocalStorage, this.isOffline, this.modalService);
      await this.modalService.showDialogWindow('views/templates/clipboardNoteDialog.html', model, true);
      if (!model.cancelled && data.Id) {
        this.data.PatientNotes.push(data);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/scripts/models/clipboardDetail.js